// extracted by mini-css-extract-plugin
module.exports = {"container":"container--Ju7Oc","fullPage":"fullPage--QS1wE","tableContainer":"tableContainer--ljlKG","withScroll":"withScroll--hrC4O","footer":"footer--y0VCf"};